import { useState, useCallback, MouseEvent } from 'react'


export const useDetailsControls = () => {
  const [detailsID, setDetailsID] = useState<string | null>(null)
  const [detailsOpened, setDetailsOpened] = useState(false)

  const closeDetails = useCallback((e: MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    e.preventDefault()
    setDetailsOpened(false)
  }, [])

  const openDetails = useCallback((ID: string) => {
    setDetailsID(ID)
    setDetailsOpened(true)
  }, [])

  return {
    detailsID,
    detailsOpened,
    closeDetails,
    openDetails,
  }
}
